module.exports = __webpack_public_path__ + "static/media/GanamosClover.beb95ef5.gif";